import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (id) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'DELETE_ORG',
    method: 'DELETE',
  });

  useEffect(() => {
    if (id) {
      exec({
        url: `/api/system/org/${id}`,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return [exec, isRequestSuccessed];
});
